var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgILanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7617 5.1875L7.64844 15.3125H9.30922L10.1702 13.2734H13.3532L14.2142 15.3125H15.875L11.7617 5.1875ZM10.8234 11.7266L11.7617 8.83848L12.7 11.7266H10.8234ZM8.5625 10.25C8.55371 10.2433 7.83863 9.69559 6.9657 8.74988C8.35719 6.8641 9.14539 4.72062 9.46707 3.71094H11.375V2.16406H6.52344V0.6875H4.97656V2.16406H0.125V3.71094H7.83301C7.49832 4.6584 6.88203 6.1543 5.94195 7.52047C4.79305 5.99328 4.28469 4.85281 4.27801 4.84086L4.02734 4.34375L2.69141 5.11719L2.93293 5.60445C2.96422 5.6593 3.53727 6.93687 4.85633 8.64793C4.88867 8.69047 4.92137 8.73195 4.95406 8.77344C3.20609 10.7724 1.81988 11.5539 1.80195 11.5673L1.25 11.9375L2.05859 13.2031L2.73711 12.7999C2.81445 12.7412 4.19012 11.9561 5.97148 9.95996C6.83352 10.8839 7.49094 11.3954 7.52891 11.4249L7.96484 11.7266L8.5625 10.25Z",
    fill: "#23272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgILanguage);
export default __webpack_public_path__ + "static/media/i-language.7dc11efc14a421b23fe0ad80f96190ff.svg";
export { ForwardRef as ReactComponent };